export const formatPhxMemberId = (
    memberId: string,
    personCode?: string | null
) => {
    return personCode && memberId.endsWith(personCode)
        ? memberId.slice(0, memberId.length - personCode.length)
        : memberId;
};
